/** VistoeraTASK-00589 — Overview multi-tab keys (home/plan/credits/team/settings only).
 * VistoeraTASK-00592 — settings sub-section deep-link via `?section=`. */

export type OverviewTabKey = 'home' | 'plan' | 'credits' | 'team' | 'settings'

export type OverviewSettingsSection = 'profile' | 'security' | 'preferences'

export const PERSONAL_OVERVIEW_TABS: OverviewTabKey[] = ['home', 'plan', 'credits', 'settings']
export const TEAM_OVERVIEW_TABS: OverviewTabKey[] = ['home', 'plan', 'credits', 'team', 'settings']

export function resolveOverviewTabs(isTeamWorkspace: boolean): OverviewTabKey[] {
  return isTeamWorkspace ? TEAM_OVERVIEW_TABS : PERSONAL_OVERVIEW_TABS
}

export function parseOverviewTab(raw: string | null | undefined, isTeamWorkspace: boolean): OverviewTabKey {
  const allowed = resolveOverviewTabs(isTeamWorkspace)
  if (raw && (allowed as string[]).includes(raw)) return raw as OverviewTabKey
  return 'home'
}

export function parseOverviewSettingsSection(
  raw: string | null | undefined,
): OverviewSettingsSection {
  if (raw === 'security' || raw === 'preferences' || raw === 'profile') return raw
  return 'profile'
}

/** Canonical personal-profile deep link: 个人概览 → 个人设置 → 个人资料. */
export function overviewPersonalProfilePath(workspaceId: string): string {
  return `/workspace/${workspaceId}/overview?tab=settings&section=profile`
}
